import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../utils/enum";
import { useMasterAuthStore } from "../../store/useMasterAuthStore";

interface LoginRequest {
    c_code: string;
    c_company_number: string;
}

interface LoginResponse {
    data: {
        accessToken: string;
        c_code: string;
        c_company_number: string;
        c_company: string;
        c_tel?: string;
        c_post?: string;
        c_addr1?: string;
        c_addr2?: string;
    };
}

export const usePostMasterLogin = (successCallback?: () => void): UseMutationResult<LoginResponse, Error, LoginRequest, unknown> => {
    const loginAsMember = useMasterAuthStore(state => state.loginAsMember);
    const queryClient = useQueryClient();

    return useMutation<LoginResponse, Error, LoginRequest>({
        mutationFn: async ({ c_code, c_company_number }) => {
            const response = await axios.post(enum_api_uri.login, {
                c_code,
                c_company_number,
            });
            return response.data;
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ["useGetMypageInfo"] });

            const info = data.data;

            loginAsMember({
                accessToken: info.accessToken,
                c_code: info.c_code,
                c_company_number: info.c_company_number,
                c_company: info.c_company,
                c_tel: info.c_tel,
                c_post: info.c_post,
                c_addr1: info.c_addr1,
                c_addr2: info.c_addr2,
            });

            successCallback?.();
        },
        onError: () => {
            alert("마스터 로그인에 실패했습니다. 상호명 또는 사업자번호를 확인해주세요.");
        },
    });
};
